<template>
    <div>
        <h6 class="font-weight-bold my-3">Enrolment Profile</h6>
        <table class="table table-sm table-striped">
            <thead class="thead-dark">
            <tr>
                <th></th>
                <th>Customers</th>
                <th>Inclusive</th>
                <th>Addon</th>
                <th>N/A</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Scheme To Date</td>
                <td>{{ enrolled.all }}</td>
                <td>{{ enrolled.all_inclusive }}</td>
                <td>{{ enrolled.all_addon }}</td>
                <td>{{ enrolled.all_noproductid }}</td>
            </tr>
            <tr>
                <td>YTD {{ year }}</td>
                <td>{{ enrolled.ytd }}</td>
                <td>{{ enrolled.ytd_inclusive }}</td>
                <td>{{ enrolled.ytd_addon }}</td>
                <td>{{ enrolled.ytd_noproductid }}</td>
            </tr>
            <tr>
                <td>{{ monthName }} {{ year }}</td>
                <td>{{ enrolled.month }}</td>
                <td>{{ enrolled.month_inclusive }}</td>
                <td>{{ enrolled.month_addon }}</td>
                <td>{{ enrolled.month_noproductid }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "ReportEnrolmentProfile",
        props: ['enrolled','year','monthName','report'],
    }
</script>

<style scoped>

</style>
